import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { getDepsByType } from '../../../fc-core/src/dependency-manager';
import { raiseWarning } from '../../../fc-core/src/event-api';

var UNDEF,
    themer,
    BLANK = '',
    OBJECTSTRING = 'object',
    arrayToStr = '[object Array]',
    objectToStr = '[object Object]',
    isImportantRegEx = /\s+!important$/,
    importantStrRegEx = /\\!important$/,
    getValueFromObjProperty = function getValueFromObjProperty(a, b) {
  var c, d;

  for (d in b = (b + '').toLowerCase(), a) {
    if (a.hasOwnProperty(d) && b === (d + '').toLowerCase()) {
      c = a[d];
      break;
    }
  }

  return c;
},
    trimString = function trimString(a) {
  a = a.replace(/^\s\s*/, '');

  for (var b = /\s/, c = a.length; b.test(a.charAt(c -= 1));) {
    ;
  }

  return a.slice(0, c + 1);
},
    getRegisteredThemes = function getRegisteredThemes(a) {
  var b,
      c = {};

  for (var d in a) {
    a.hasOwnProperty(d) && (b = a[d], c[b.name] = b);
  }

  return c;
},
    checkCyclicRef = function checkCyclicRef(a, b) {
  for (var c = b.length, d = -1; c--;) {
    if (a === b[c]) return d = c, d;
  }

  return d;
},
    merge = function merge(a, b, c, d, e) {
  var f, g, h, i, j;
  if (e ? (d.push(a), e.push(b)) : (d = [a], e = [b]), b instanceof Array) for (f = 0; f < b.length; f += 1) {
    try {
      g = a[f], h = b[f];
    } catch (a) {
      continue;
    }

    typeof h == OBJECTSTRING ? ((null === g || typeof g != OBJECTSTRING) && (g = a[f] = h instanceof Array ? [] : {}), j = checkCyclicRef(h, e), -1 === j ? merge(g, h, c, d, e) : g = a[f] = d[j]) : !(c && h === UNDEF) && (a[f] = h);
  } else for (f in b) {
    try {
      g = a[f], h = b[f];
    } catch (a) {
      continue;
    }

    null !== h && typeof h == OBJECTSTRING ? (i = Object.prototype.toString.call(h), i === objectToStr ? ((null === g || typeof g != OBJECTSTRING) && (g = a[f] = {}), j = checkCyclicRef(h, e), -1 === j ? merge(g, h, c, d, e) : g = a[f] = d[j]) : i === arrayToStr ? ((null === g || !(g instanceof Array)) && (g = a[f] = []), j = checkCyclicRef(h, e), -1 === j ? merge(g, h, c, d, e) : g = a[f] = d[j]) : a[f] = h) : a[f] = h;
  }
  return a;
},
    extend2 = function extend2(a, b, c) {
  return typeof a != OBJECTSTRING && typeof b != OBJECTSTRING ? null : typeof b != OBJECTSTRING || null === b ? a : (typeof a != OBJECTSTRING && (a = b instanceof Array ? [] : {}), merge(a, b, c), a);
},
    checkImportance = function checkImportance(a) {
  var b = {
    important: !1,
    str: BLANK
  };
  return a ? (a = a.toString(), isImportantRegEx.test(a) ? (a = a.replace(isImportantRegEx, BLANK), b.important = !0) : (a = a.replace(importantStrRegEx, '!imporant'), b.important = !1), b.str = a, b) : b;
},
    mergeThemeWithData = function mergeThemeWithData(a, b) {
  var c,
      d,
      e,
      f = b.getAll();

  for (c in f) {
    d = f[c].toString(), e = checkImportance(d), e.important ? a[c.toLowerCase()] = e.str : a[c.toLowerCase()] === UNDEF && (a[c.toLowerCase()] = e.str);
  }
},
    onChartTypeChange = function onChartTypeChange(a) {
  var b,
      c = a.sender,
      d = c.getChartData();
  d.error || (b = d && (d.chart && d.chart.theme || d.map && d.map.theme), b ? (d.map && (d.chart = d.map, delete d.map), themer.themify(b, c, c.chartType(), d, 'geo' === c.apiInstance.defaultSeriesType && 'geo')) : c.jsVars && c.jsVars.themeObject && c.jsVars.themeObject.dispose());
},
    recursiveApply = function recursiveApply(a, b) {
  var c,
      d,
      e,
      f,
      g,
      h,
      j = 0,
      k = 0;

  for (c in a) {
    if (d = a[c], d instanceof Array) for (h = d.length, g = 0; g < h; g += 1) {
      f = d[g], 'object' == typeof f && ('category' === c ? 'true' === f.vline ? (e = b.component('vline', j, f), e && (mergeThemeWithData(f, e), j += 1)) : (e = b.component('category', k, f, h), e && (mergeThemeWithData(f, e), k += 1)) : (e = b.component(c, g, f, h), e && (mergeThemeWithData(f, e), recursiveApply(f, e))));
    } else 'object' == typeof d && (e = b.component(c, null, d), e && (mergeThemeWithData(d, e), recursiveApply(d, e)));
  }
};

var ThemeManager =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(ThemeManager, _ComponentInterface);

  function ThemeManager() {
    _classCallCheck(this, ThemeManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemeManager).apply(this, arguments));
  }

  _createClass(ThemeManager, [{
    key: "configure",
    value: function configure() {
      this.config.themeStore || (this.config.themeStore = {});
    }
  }, {
    key: "add",
    value: function add(a) {
      for (var b, c = this, d = 0, e = a.length; d < e; d += 1) {
        b = a[d].name, b && (c.config.themeStore[b] = a[d]);
      }
    }
  }, {
    key: "themify",
    value: function themify(a, b, c, d, e) {
      var f,
          g,
          h = this,
          j = b.jsVars,
          k = a.split(','),
          l = [],
          m = k.length;

      if (h.config.themeStore = getRegisteredThemes(getDepsByType('theme')), m) {
        for (g = 0; g < m; g += 1) {
          f = h.config.themeStore[trimString(k[g])], f && l.push(ThemeManager.evaluateThemeJSON(f.theme, b, c, e));
        }

        l.length ? (j.themeObject = new ThemeInstance(l, b, !1, d), ThemeManager.applyTheme(b), !h._attachedListeners && (b.addEventListener('chartTypeChanged', onChartTypeChange), h._attachedListeners = !0)) : raiseWarning(b, '14051100501', 'run', 'api.themes~themify()', 'The theme "' + a + '" requested has not been registered.');
      }
    }
  }], [{
    key: "evaluateThemeJSON",
    value: function evaluateThemeJSON(a, b, c, d) {
      var e,
          f,
          g = {},
          h = b.jsVars,
          i = function i(a) {
        var b, c;

        for (b in a) {
          c = a[b], g[b] = c instanceof Array ? extend2(g[b] || [], c) : 'object' == typeof c ? extend2(g[b] || {}, c) : c;
        }
      };

      return c = c || b.chartType(), h.themeObject && a !== h.themeObject && (h.themeObject.dispose(), delete h.themeObject), i(getValueFromObjProperty(a, 'base')), d && (e = getValueFromObjProperty(a, d)), e && i(e), c && (f = getValueFromObjProperty(a, c)), f && i(f), g;
    }
  }, {
    key: "applyTheme",
    value: function applyTheme(a) {
      var b = a.jsVars.themeObject,
          c = b.getThemedJSONData().data;
      c && recursiveApply(c, b);
    }
  }]);

  return ThemeManager;
}(ComponentInterface);

var ThemeInstance =
/*#__PURE__*/
function (_ComponentInterface2) {
  _inherits(ThemeInstance, _ComponentInterface2);

  function ThemeInstance(a, b, c, d) {
    var _this;

    _classCallCheck(this, ThemeInstance);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ThemeInstance).call(this));
    var e,
        f = 0;

    for (_this.themeArray = a, _this.themeComponents = {}, _this.base = {}, _this.chartInstance = b, _this.isChildInstance = !!c, _this.themedData = c ? null : extend2({
      chart: {}
    }, d), _this.length = a.length, e = a.length; f < e; f += 1) {
      _this.parse(a[f]);
    }

    return _this;
  }

  _createClass(ThemeInstance, [{
    key: "pushTheme",
    value: function pushTheme(a) {
      a && (this.themeArray.push(a), this.parse(a), this.length += 1);
    }
  }, {
    key: "parse",
    value: function parse(a) {
      var b,
          c,
          d,
          e,
          f,
          g = this,
          h = g.themeComponents,
          i = g.chartInstance,
          j = g.base;

      for (c in f = a, f) {
        'string' == typeof f[c] || 'number' == typeof f[c] ? j[c] ? (d = checkImportance(f[c]), e = checkImportance(j[c]), (d.important || !e.important) && (j[c] = f[c])) : j[c] = f[c] : (h[c] || (h[c] = []), b = h[c], f[c] instanceof Array ? b.push(extend2([], f[c])) : 'object' == typeof f[c] ? b.push(new ThemeInstance([f[c]], i, !0)) : 'function' == typeof f[c] && b.push(f[c]));
      }
    }
  }, {
    key: "merge",
    value: function merge(a) {
      var b,
          c,
          d,
          e = this,
          f = e.base,
          g = a.base,
          h = e.themeComponents,
          i = a.themeComponents;

      for (d in g) {
        b = checkImportance(f[d]), c = checkImportance(g[d]), (!b.important || c.important) && (f[d] = g[d]);
      }

      for (d in i) {
        h[d] = h[d] ? h[d].concat(i[d]) : [].concat(i[d]);
      }

      e.length += a.length;
    }
  }, {
    key: "get",
    value: function get(a) {
      return this.base[a];
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return extend2({}, this.base);
    }
  }, {
    key: "component",
    value: function component(a, b, c, d) {
      var e,
          f,
          g,
          h,
          j,
          k,
          l = this,
          m = l.themeComponents,
          n = l.chartInstance,
          o = new ThemeInstance([], n, !0);
      if (j = m[a], !j) return null;

      for (f = 0, g = j.length; f < g; f += 1) {
        k = j[f], 'function' == typeof k ? (b = b || 0, o.pushTheme(k.call(n, b, c, d))) : k instanceof Array ? (b = b || 0, h = k.length, b %= h, e = k[b], e instanceof ThemeInstance ? o.merge(e) : 'function' == typeof e ? o.pushTheme(e.call(n, b, c, d)) : o.pushTheme(e)) : k instanceof ThemeInstance ? o.merge(k) : o.pushTheme(k);
      }

      return o;
    }
  }, {
    key: "getThemedJSONData",
    value: function getThemedJSONData() {
      return {
        data: this.themedData
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      var a,
          b,
          c = this,
          d = c.themeComponents,
          e = c.chartInstance;

      for (a in d) {
        if (b = d[a].length, b) {
          for (; b--;) {
            d[a][b].dispose && d[a][b].dispose();
          }

          delete d[a];
        }
      }

      !c.isChildInstance && e && e.removeEventListener('chartTypeChanged', onChartTypeChange), c.themeComponents = null, c.chartInstance = null, c.base = null, c.themeArray = null, c.isChildInstance = null, c.dataWithoutTheme = null;
    }
  }]);

  return ThemeInstance;
}(ComponentInterface);

themer = new ThemeManager(), themer.configure();

function FCPlugger(a) {
  var b = function b(_b) {
    var c,
        d,
        e,
        f = _b.sender,
        g = getRegisteredThemes(getDepsByType('theme')),
        h = f.getChartData(),
        j = a.options.defaultTheme,
        k = h && (h.chart && h.chart.theme || h.map && h.map.theme),
        l = (j || k) && "".concat(j || '', ",").concat(k || ''),
        m = l && l.split(','),
        n = m && m.length,
        o = !1;

    for (d = 0; d < n; d++) {
      e = trimString(m[d]), g && '' !== e && g.hasOwnProperty(e) && (o = !0);
    }

    o ? (c = f.chartType(), h.map && (h.chart = h.map, delete h.map), themer.themify(l, f, c, h, 'geo' === f.apiInstance.defaultSeriesType && 'geo')) : f.jsVars && f.jsVars.themeObject && (f.jsVars && f.jsVars.themeObject.dispose(), f.jsVars && delete f.jsVars.themeObject);
  };

  a.addEventListener('beforedataload', b), a.addEventListener('charttypechanged', b);
}

export default {
  extension: FCPlugger,
  name: 'ThemeEngine',
  type: 'extension',
  requiresFusionCharts: !0
};